var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserRoundPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5C0.999929 9.85305 1.15676 9.21578 1.45704 8.64279C1.75732 8.0698 2.19209 7.57819 2.72408 7.21011C3.25606 6.84203 3.86938 6.60847 4.51144 6.52946C5.1535 6.45045 5.80515 6.52834 6.4105 6.75645M10.689 8.31295C10.8882 8.11377 11.0001 7.84363 11.0001 7.56195C11.0001 7.28027 10.8882 7.01013 10.689 6.81095C10.4898 6.61177 10.2197 6.49988 9.93799 6.49988C9.65631 6.49988 9.38617 6.61177 9.18699 6.81095L7.18199 8.81695C7.06311 8.93576 6.9761 9.08262 6.92899 9.24395L6.51049 10.679C6.49794 10.722 6.49719 10.7676 6.50831 10.811C6.51943 10.8544 6.54202 10.894 6.57371 10.9257C6.6054 10.9574 6.64503 10.98 6.68844 10.9911C6.73186 11.0023 6.77746 11.0015 6.82049 10.989L8.25549 10.5705C8.41682 10.5233 8.56368 10.4363 8.68249 10.3175L10.689 8.31295ZM7.5 4C7.5 5.38071 6.38071 6.5 5 6.5C3.61929 6.5 2.5 5.38071 2.5 4C2.5 2.61929 3.61929 1.5 5 1.5C6.38071 1.5 7.5 2.61929 7.5 4Z",
    stroke: "#525062",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRoundPen);
export default __webpack_public_path__ + "static/media/UserRoundPen.9c00b8ce3c1afb4b4bb512658cf4a9e8.svg";
export { ForwardRef as ReactComponent };